/* Polsk katalog for locale-sales-payments-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inv.unknownAccount': 'Nieznane konto',
  'inv.refund.customerBalance': "Saldo na korzyść klienta",
  'inv.refund.balanceHelp': "Saldo obejmuje korekty faktur oraz wpłaty i zwroty wymienione poniżej.",
  'inv.refund.addFee': "Dodaj opłatę",
  'inv.refund.businessFee': "Opłata ponoszona przez firmę",
  'inv.refund.customerReceives': "Klient otrzymuje",
  'inv.refund.accountDebit': "Łączne obciążenie konta",
  'sale.pay.ownerDebt': "Krótkoterminowe zobowiązania wobec właścicieli",
  'sale.pay.title': 'Płatność',
  'sale.pay.help': 'Wybierz, na które konto i w jakim dniu opłacono sprzedaż. Dodaj opłatę lub podziel płatność na kilka wpłat. Suma musi zgadzać się z pozycjami sprzedaży.',
  'sale.pay.paidTo': 'Zapłacono na',
  'sale.pay.choosePaymentAccount': 'Wybierz konto płatności',
  'sale.create.needPaymentAccount': 'Wybierz „Zapłacono na”, zanim zarejestrujesz sprzedaż.',
  'sale.pay.paidDate': 'Data płatności',
  'sale.pay.fee': 'Opłata',
  'sale.pay.addFee': 'Dodaj opłatę',
  'sale.pay.removeFee': 'Usuń opłatę',
  'sale.pay.partial': 'Płatności częściowe',
  'sale.pay.addPartial': 'Dodaj płatność częściową',
  'sale.pay.removePartial': 'Usuń płatność częściową',
  'sale.pay.seeTransaction': 'Zobacz transakcję',
  'sale.pay.addAccount': 'Dodaj konto',
  'sale.pay.addCard': 'Dodaj kartę kredytową',
  'sale.pay.addBankTitle': 'Dodaj rachunek bankowy',
  'sale.pay.addCardTitle': 'Dodaj kartę kredytową',
  'sale.pay.addSolutionTitle': 'Dodaj rozwiązanie płatnicze',
  'sale.pay.solution': 'Rozwiązanie płatnicze',
  'sale.pay.accountType': 'Typ konta',
  'sale.pay.cardOwner': 'Karta należy do',
  'sale.pay.displayName': 'Nazwa wyświetlana (opcjonalnie)',
  'sale.pay.orgNumber': 'Numer org.',
  'sale.pay.openingBalance': 'Saldo początkowe do uzgadniania',
  'sale.pay.openingBalanceDate': 'Data salda początkowego',
  'sale.pay.resetChoice': 'Wyczyść wybór',
  'sale.cust.helpTitle': 'Klient sprzedaży',
  'sale.cust.help': 'Tutaj wybierasz, kogo dotyczy sprzedaż. Wyszukaj zapisanego klienta, listę lub subskrypcję — albo naciśnij „Nowy klient”, aby wpisać odbiorcę, który nie jest jeszcze zapisany. Nazwa i adres są automatycznie przenoszone na dokument.',
  'sale.cust.optionalHelp': 'W przypadku innej sprzedaży klient jest opcjonalny. Włącz, jeśli chcesz powiązać sprzedaż z konkretnym klientem.',
  'sale.cust.search': 'Szukaj klientów, list i subskrypcji...',
  'sale.cust.pickExisting': 'Wybierz istniejącego',
  'sale.cust.new': 'Nowy klient',
  'sale.cust.add': 'Dodaj klienta',
  'sale.cust.selected': 'Wybrany klient',
  'sale.cust.selectedList': 'Wybrana lista odbiorców',
  'sale.cust.none': 'Nie wybrano jeszcze klienta',
  'sale.cust.listsAndSubs': 'Listy i subskrypcje',
  'sale.cust.detailsTitle': 'Dane klienta',
  'sale.cust.name': 'Nazwa klienta',
  'sale.cust.namePh': 'Np. Przykład AS',
  'sale.cust.number': 'Nr klienta',
  'sale.cust.org': 'Nr org.',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adres',
  'sale.cust.addressPh': 'Ulica, kod pocztowy i miejscowość',
  'sale.cust.email': 'E-mail',
  'sale.cust.emailPh': 'kontakt@przyklad.pl',
  'sale.cust.phone': 'Telefon',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Osoby kontaktowe',
  'sale.cust.noContacts': 'Nie dodano osób kontaktowych.',
  'sale.cust.addContact': 'Dodaj osobę kontaktową',
  'sale.cust.removeContact': 'Usuń osobę kontaktową',
  'sale.cust.contactName': 'Imię i nazwisko',
  'sale.cust.contactNamePh': 'Np. Jan Kowalski',
  'sale.cust.contactRole': 'Rola',
  'sale.cust.contactRolePh': 'Np. Księgowość',
  'sale.cust.outstanding': 'Do zapłaty',
  'sale.cust.revenueToDate': 'Obrót do tej pory',
  'sale.cust.pickPh': 'Klient lub numer',
  'sale.cust.select': 'Wybierz klienta',
  'sale.cust.use': 'Użyj klienta',
  'sale.cust.noEmail': 'Brak e-maila klienta',
  'sale.cust.listDefaultName': 'Lista klientów',
  'sale.cust.updatedToast': 'Zaktualizowano klienta w sprzedaży',
  'sale.cust.noCustomerHelp': 'Sprzedaż jest rejestrowana bez klienta. Włącz przełącznik, jeśli chcesz powiązać ją z klientem.',
  'sale.cust.selectHint': 'Wybierz zapisanego klienta, listę lub subskrypcję - albo użyj „Nowy klient” do swobodnego wpisu.',
  'sale.cust.recipientsCount': 'Odbiorcy: {count}',
  'sale.cust.kindSubscription': 'Subskrypcja',
  'sale.cust.kindList': 'Lista',
  'sale.cust.noMatches': 'Brak wyników dla „{query}”.',
  'sale.cust.addAsNew': 'Dodaj „{query}” jako nowego klienta',
  'sale.cust.contactDefaultName': 'Osoba kontaktowa {n}',
  'sale.cust.saveFailed': 'Nie udało się zapisać klienta.',
  'sale.pay.accountNameSavings': 'Rachunek oszczędnościowy',
  'sale.pay.accountNameOperating': 'Rachunek firmowy',
  'sale.pay.accountNamePrivate': 'Rachunek prywatny',
  'sale.pay.accountNameBank': 'Rachunek bankowy',
  'sale.pay.groupBank': 'Rachunki bankowe',
  'sale.pay.groupCard': 'Karty kredytowe',
  'sale.pay.groupPrivate': 'Prywatne',
  'sale.pay.groupOther': 'Inne',
  'sale.pay.groupGeneric': 'Konta',
  'sale.pay.cashLabel': 'Gotówka',
  'sale.pay.bankNameRequired': 'Nadaj nazwę rachunkowi bankowemu',
  'sale.pay.accountOrCardNameRequired': 'Nadaj nazwę kontu lub karcie',
  'sale.pay.accountNumberRequired': 'Wpisz numer rachunku',
  'sale.pay.bankAccountAdded': 'Dodano rachunek bankowy',
  'sale.pay.privateAccountAdded': 'Dodano rachunek prywatny',
  'sale.pay.saveAccountFailed': 'Nie udało się zapisać konta.',
  'sale.pay.accountsUnavailable': 'Konta płatności nie są połączone z backendem.',
  'sale.pay.openingSetupRequired': 'Wpisz datę rozpoczęcia i saldo początkowe. Wpisz 0, jeśli saldo wynosiło zero.',
  'sale.pay.invalidLedgerAccount': 'W planie kont brakuje prawidłowego numeru konta.',
  'sale.pay.accountExists': 'Konto {code} już istnieje.',
  'sale.pay.typePrivateCard': 'Rachunek prywatny / karta',
  'sale.pay.newBankAccountNote': 'W planie kont zostanie utworzony nowy rachunek bankowy',
  'sale.pay.newPrivateAccountNote': 'W planie kont zostanie utworzony nowy rachunek prywatny/karta',
  'sale.pay.bankAccountSeriesInfo': 'Rachunki bankowe otrzymują następne wolne konto z serii 192x.',
  'sale.pay.privateAccountSeriesInfo': 'Prywatne karty/rachunki otrzymują następne wolne konto rozrachunkowe z serii 206x.',
  'sale.pay.thisGetsAccount': 'Otrzyma konto',
  'sale.pay.accountNameLabel': 'Nazwa konta',
  'sale.pay.accountOrCardNameLabel': 'Nazwa konta / karty',
  'sale.pay.accountNamePhBank': 'Np. Rachunek firmowy 2',
  'sale.pay.accountNamePhPrivate': 'Np. Karta właściciela Visa',
  'sale.pay.accountNumberLabel': 'Numer konta',
  'sale.pay.accountCardRefLabel': 'Konto / numer karty / referencja (opcjonalnie)',
  'sale.pay.interimAccountPrefix': 'Rozrachunki',
  'sale.pay.cardNameRequired': 'Nadaj nazwę karcie kredytowej',
  'sale.pay.cardNumberRequired': 'Wpisz numer karty/rachunku',
  'sale.pay.openingBalanceRequired': 'Wpisz saldo początkowe i jego datę',
  'sale.pay.creditCardDebtPrefix': 'Zadłużenie karty kredytowej',
  'sale.pay.cardAdded': 'Dodano kartę kredytową',
  'sale.pay.saveCardFailed': 'Nie udało się zapisać karty kredytowej.',
  'sale.pay.scopeBusiness': 'Firma',
  'sale.pay.businessCardNote': 'Karty firmowe są księgowane jako osobne zadłużenie karty',
  'sale.pay.privateCardNote': 'Karty prywatne są księgowane jako rozrachunki',
  'sale.pay.businessCardSeriesInfo': 'Karty firmowe, które nie są rachunkiem bankowym, otrzymują następne wolne konto z serii 238x.',
  'sale.pay.privateCardSeriesInfo': 'Karty prywatne otrzymują następne wolne konto rozrachunkowe z serii 206x.',
  'sale.pay.accountInLedger': 'Konto w księgowości:',
  'sale.pay.cardNamePhBusiness': 'Np. Karta firmowa Visa',
  'sale.pay.cardNamePhPrivate': 'Np. Karta właściciela Mastercard',
  'sale.pay.cardNumberLabel': 'Numer karty / numer rachunku',
  'sale.pay.cardNumberLabelOptional': 'Numer karty / numer rachunku (opcjonalnie)',
  'sale.pay.otherSolution': 'Inne rozwiązanie płatnicze',
  'sale.pay.settlementPrefix': 'Rozliczenie',
  'sale.pay.solutionAdded': 'Dodano rozwiązanie płatnicze',
  'sale.pay.saveSolutionFailed': 'Nie udało się zapisać rozwiązania płatniczego.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe i podobne są księgowane na osobnym koncie rozliczeniowym rozwiązania płatniczego, które uzgadnia się po wypłacie rozliczenia na rachunek bankowy.',
  'sale.pay.addCardAction': '+ Dodaj kartę kredytową ...',
  'sale.pay.addSolutionAction': '+ Dodaj rozwiązanie płatnicze ...',
  'sale.pay.partialLabel': 'Płatność częściowa {n}',
  'sale.pay.partialStatusRemaining': 'pozostało',
  'sale.pay.partialStatusTooMuch': 'za dużo',
  'sale.pay.partialStatusMatches': 'zgadza się',
  'sale.pay.partialSummary': 'Zapłacono {paid} z {expected} · {status}',
  'sale.pay.partialMismatch': 'Suma płatności częściowych musi być równa sumie sprzedaży{feeSuffix} ({expected}).',
  'sale.list.noMembers': 'Lista nie zawiera klientów do zafakturowania.',
  'sale.list.customerMissing': 'Klient już nie istnieje.',
  'sale.list.noneCreated': 'Nie utworzono żadnych faktur.',
  'sale.list.missingEmailNotice': 'Faktury utworzone dla klientów bez e-maila, które trzeba wysłać lub wydrukować ręcznie ({count}): {names}',
  'sale.list.notCreatedNotice': 'Nie ukończono dla: {names}',
  'sale.list.createdNoEmail': 'Faktura została utworzona, ale klient nie ma adresu e-mail. Wyślij ją lub wydrukuj ręcznie.',
  'sale.list.noneSent': 'Faktury zostały utworzone, ale żadna nie została wysłana e-mailem. Wyślij lub wydrukuj ręcznie: {names}',
  'sale.list.recipientsCount': 'Odbiorcy: {count}',
  'sale.list.sentPartly': 'Wysłano do odbiorców: {sent}. Nie wysłano: {names}',
  'sale.list.sentAll': 'Wysłano do odbiorców: {sent}.',
  'sale.pay.partialMismatchFeeSuffix': ' minus opłata',
  'sale.pay.feeTooHigh': 'Opłata nie może być większa niż sprzedaż ({gross}).',
  'sale.pay.splitMismatchError': 'Płatności częściowe ({paid}) muszą łącznie być równe sumie sprzedaży minus opłata ({expected}).',
  'sale.product.backendUnavailable': 'Zapisywanie produktów nie jest połączone z backendem.',
  'sale.product.added': 'Dodano produkt „{name}”',
  'sale.product.updated': 'Zaktualizowano produkt „{name}”',
  'sale.product.saveFailed': 'Nie udało się zapisać produktu.',
  'sale.create.backendUnavailable': 'Nowa sprzedaż nie jest połączona z backendem.',
});
